import React from "react";
import { useHelpCentreConfig } from "~/services/queries/variable.queries";
import { useTranslation } from "~/lib/utils/store/useTranslation";
import { Topic } from "./Topic";

export const AllTopics = () => {
  const { data: helpCentreConfig } = useHelpCentreConfig();
  const { t } = useTranslation();

  return (
    <div className="p-5 md:p-0 flex flex-col gap-5">
      <div className="text-xl font-semibold font-title">
        {t("browseHelpTopics")}
      </div>
      <div className="font-medium text-lg md:space-y-0 flex flex-col gap-4 md:gap-5">
        {helpCentreConfig?.TOPICS?.map((topic) => {
          return <Topic key={topic.sectionId} data={topic} />;
        })}
      </div>
    </div>
  );
};

export default AllTopics;
